import React from 'react';

import {Modal, ModalBody} from 'reactstrap';

import {SIGNUP_PAGE_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

export const TrialModalContext = React.createContext<() => any>(() => null);

interface Props {
  children: React.ReactNode;
}

export function StartTrialModalWithContext({children}: Props): JSX.Element {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleModal = () => setIsOpen((isOpen) => !isOpen);

  return (
    <TrialModalContext.Provider value={toggleModal}>
      {children}
      <Modal isOpen={isOpen} toggle={toggleModal}>
        <ModalBody>
          <div className="text-center p-3">
            <h3 className="font-weight-bold">{gt('Try the Full Version')}</h3>
            <p className="lead my-4">
              {gt(
                'We have so much more to show you. Explore SweetProcess today.'
              )}
            </p>
            <a className="btn btn-lg btn-primary" href={SIGNUP_PAGE_URL}>
              {gt('Start Free Trial')} <i className="fa fa-fw fa-caret-right" />
            </a>
          </div>
        </ModalBody>
      </Modal>
    </TrialModalContext.Provider>
  );
}
